import CCScatterChart from "../Common/CCScatterChart";
import {prepareBuffer} from "../../util/Buffer";

class ExampleScatterChart extends CCScatterChart {
    constructor(props) {
        super(props);

        this.state.fetchBackgroundOperation = false
    };

    componentDidMount() {
        super.componentDidMount();

        const pData = [
            {x: 100, y: 200, id: 1},
            {x: 120, y: 100, id: 2},
            {x: 170, y: 300, id: 3},
            {x: 140, y: 250, id: 4},
            {x: 150, y: 400, id: 5},
            {x: 110, y: 280, id: 6},
        ];
        const uData = [
            {x: 300, y: 300, id: 1},
            {x: 400, y: 500, id: 2},
            {x: 200, y: 700, id: 3},
            {x: 340, y: 350, id: 4},
            {x: 560, y: 500, id: 5},
            {x: 230, y: 780, id: 6},
        ];

        let series = structuredClone(this.props.Series ?? [{}, {}]);
        series[0].data = pData;
        series[1].data = uData;

        this.setState({Loading: this.state.fetchBackgroundOperation, Series: series});

        this.applet.getEnterpriseComponent().executeQuery(1,100000);
    }

    enterpriseComponentLoadStarted = () => {
        this.setState({Loading: true});
    };

    enterpriseComponentLoadCompleted = (ec) => {
        let buffer = prepareBuffer(ec);

        let series = structuredClone(this.state.Series);
        if (series.length === 0) {
            series = [{data: []}, {data: []}]
        }
        series[0].data = []
        series[1].data = []
        for (let i = 0; i < buffer.length; i++) {
            series[0].data.push({
                x: parseFloat(buffer[i].get("X_AXIS")),
                y: parseFloat(buffer[i].get("Y_AXIS_2")),
                id: i,
            });
            series[1].data.push({
                x: parseFloat(buffer[i].get("X_AXIS")),
                y: parseFloat(buffer[i].get("Y_AXIS_1")),
                id: i,
            });
        }

        this.setState({Loading: false, Series: series});
    };
}

export default ExampleScatterChart;
